import { FlightsPage, CmsContentPage } from '@honeycomb/ui';
import {
    getPageAndGlobalProps,
    getFacadeContentQuery,
    FunnelQueryParamsEnum,
    GetFacadeContentQuery,
    GlobalQuery,
} from '@honeycomb/data';
import { GetServerSidePropsContext } from 'next';

export default function Flights(props: GetFacadeContentQuery | GlobalQuery): React.JSX.Element {
    if ('getPage' in props) {
        const { getPage } = props;
        return <CmsContentPage {...{ getPage }} />;
    }

    return <FlightsPage />;
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    const isFunnelSRP = Object.values(FunnelQueryParamsEnum).some((param) =>
        Object.keys(context.query).includes(param)
    );
    if (isFunnelSRP) {
        return getPageAndGlobalProps(context as GetServerSidePropsContext);
    }
    return getPageAndGlobalProps<GetFacadeContentQuery, GetServerSidePropsContext>(
        context,
        getFacadeContentQuery('flights', [], context.query?.isPreview)
    );
}
